// extracted by mini-css-extract-plugin
export default {"application":"styles_application__jFs0q","menuWrapper":"styles_menuWrapper__Ij0Gu","applicationWrapper":"styles_applicationWrapper__-tlL0","left":"styles_left__umeJm"};